import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-quotes',
    templateUrl: './quotes-router.component.html',
    styleUrls: ['./quotes-router.component.scss'],
    imports: [RouterOutlet]
})
export class QuotesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
